<app-modal-wrapper
  [title]="id ? 'Edit Currency: #' + id : 'New Currency'"
  [isDirty]="currencyForm?.dirty ?? false"
  [formValid]="isFormValid"
  [showSaveButton]="true"
  [saveLoading]="submitting"
  [keepEditingLabel]="id ? 'Keep editing' : 'Keep creating'"
  (save)="newOrSaveRecord()"
  (closeRequest)="ref.close()"
>
  <form #currencyForm="ngForm" class="flex flex-col gap-6">
    <!-- Tenant (read-only, global admin only) -->
    <div *ngIf="isGlobalAdmin && id" class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide"
        >Tenant</label
      >
      <div
        class="flex items-center h-[38px] px-3 bg-gray-50 border border-gray-200 rounded-md text-sm text-gray-500 font-medium"
      >
        <i class="pi pi-server mr-2 text-gray-400"></i>
        {{ tenantName || "—" }}
      </div>
    </div>

    <!-- Name -->
    <div class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
        Name <span class="text-red-500">*</span>
      </label>
      <input
        pInputText
        type="text"
        name="name"
        [(ngModel)]="model.name"
        placeholder="Ex: Real Brasileiro (BRL)"
        class="w-full"
        required
      />
    </div>

    <!-- Acronym + Flag (row) -->
    <div class="flex gap-4">
      <!-- Acronym -->
      <div class="flex flex-col gap-1 flex-1">
        <label
          class="font-bold text-gray-700 text-xs uppercase tracking-wide"
        >
          Acronym <span class="text-red-500">*</span>
        </label>
        <input
          pInputText
          type="text"
          name="acronym"
          [(ngModel)]="model.acronym"
          placeholder="Ex: BRL"
          class="w-full uppercase"
          maxlength="5"
          required
          (input)="model.acronym = model.acronym?.toUpperCase()"
        />
      </div>

      <!-- Flag -->
      <div class="flex flex-col gap-1 flex-1">
        <label
          class="font-bold text-gray-700 text-xs uppercase tracking-wide"
        >
          Flag <span class="text-red-500">*</span>
        </label>
        <p-select
          name="flag"
          [(ngModel)]="model.flag"
          [options]="flagOptions"
          placeholder="Select a flag..."
          styleClass="w-full"
          [filter]="true"
          appendTo="body"
          required
        >
          <ng-template pTemplate="item" let-code>
            <div class="flex items-center gap-2">
              <img [src]="'assets/img/flags/' + code + '.png'" class="h-4 shrink-0" [alt]="code" />
              <span>{{ code }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="selectedItem" let-code>
            <div class="flex items-center gap-2" *ngIf="code">
              <img [src]="'assets/img/flags/' + code + '.png'" class="h-4 shrink-0" [alt]="code" />
              <span>{{ code }}</span>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>
  </form>
</app-modal-wrapper>
